import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/sample/group-a')({
  component: () => (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ marginBottom: '10px', color: '#333' }}>Pathless Route Group: Group A</h1>
      <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
        괄호로 묶인 디렉토리는 라우트 구조에 영향을 주지 않습니다. 순전히 파일 정리 용도입니다.
      </p>
      <p style={{ padding: '10px', background: '#e7f3ff', borderRadius: '4px', marginBottom: '20px', color: '#666' }}>
        💡 이 파일은 (sample) 디렉토리 내부에 있지만 URL은 /group-a 입니다.
      </p>
      <nav>
        <Link to="/" style={{ marginRight: '10px', color: '#0066cc' }}>← 홈으로</Link>
        <span style={{ margin: '0 5px', color: '#999' }}>|</span>
        <Link to="/group-b" style={{ color: '#0066cc' }}>Group B</Link>
      </nav>
    </div>
  ),
});

